<h2>{{ "Change Password" | translate }}</h2>
<form [formGroup]="form" (submit)="handleSubmit()">
    <mat-form-field appearance="outline" color="primary">
        <mat-label>{{ "Old Password" | translate }}</mat-label>
        <input formControlName="PASSWORD" matInput required="" [type]="showPassword() ? 'text' : 'password'"/>
        @if (oldPassword?.hasError("required")) {
            <mat-error>{{ "Old password is required" | translate }}</mat-error>
        }
        <button matSuffix mat-icon-button aria-label="show or hide password" (click)="togglePasswordVisibility()">
            <mat-icon>{{showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
    </mat-form-field>
    <div style="display: flex; flex-direction: column; gap: 10px">
        <mat-form-field appearance="outline" color="primary" style="width: 100%">
            <mat-label>{{ "New Password" | translate }}</mat-label>
            <input
                    formControlName="NEW_PASSWORD"
                    matInput
                    required=""
                    [type]="showPassword() ? 'text' : 'password'"
            />
            @if (newPassword?.hasError("required")) {
                <mat-error>{{ "New password is required" | translate }}</mat-error>
            }
            <!--            @if (newPassword?.hasError("pattern")) {-->
            <!--                <mat-error>-->
            <!--                    {{-->
            <!--                        "Password must be 8+ characters with uppercase, lowercase, number, and symbol"-->
            <!--                            | translate-->
            <!--                    }}-->
            <!--                </mat-error>-->
            <!--            }-->
            <button matSuffix mat-icon-button aria-label="generate random password" (click)="generateRandomPassword()">
                <mat-icon>bolt</mat-icon>
            </button>
            <button matSuffix mat-icon-button aria-label="show or hide password" (click)="togglePasswordVisibility()">
                <mat-icon>{{showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <mat-form-field appearance="outline" color="primary">
        <mat-label>{{ "Confirm Password" | translate }}</mat-label>
        <input
                formControlName="CONFIRM_PASSWORD"
                matInput
                [required]="true"
                [type]="showPassword() ? 'text' : 'password'"
        />
        @if (form.controls["CONFIRM_PASSWORD"]?.hasError("required")) {
            <mat-error>{{ "Confirm password is required" | translate }}</mat-error>
        }
        <button matSuffix mat-icon-button aria-label="show or hide password" (click)="togglePasswordVisibility()">
            <mat-icon>{{showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
    </mat-form-field>

    <div id="validation-steps">
        <app-password-validation-step
                [isDirty]="Boolean(newPassword?.dirty || confirmPassword?.dirty)"
                [error]="newPassword?.errors?.['required'] || newPassword?.errors?.['missingUpperCase']"
                [validationMessage]="'validation.missingUpperCase' | translate: { amount: 1 }"/>
        <app-password-validation-step
                [isDirty]="Boolean(newPassword?.dirty || confirmPassword?.dirty)"
                [error]="newPassword?.errors?.['required'] || newPassword?.errors?.['missingLowerCase']"
                [validationMessage]="'validation.missingLowerCase' | translate: { amount: 1 }"/>
        <app-password-validation-step
                [isDirty]="Boolean(newPassword?.dirty || confirmPassword?.dirty)"
                [error]="newPassword?.errors?.['required'] || newPassword?.errors?.['missingNumbers']"
                [validationMessage]="'validation.missingNumbers' | translate: { amount: 3 }"/>
        <app-password-validation-step
                [isDirty]="Boolean(newPassword?.dirty || confirmPassword?.dirty)"
                [error]="newPassword?.errors?.['required'] || newPassword?.errors?.['missingSpecialCharacter']"
                [validationMessage]="'validation.missingSpecialCharacter' | translate: { amount: 1 }"/>
        <app-password-validation-step
                [isDirty]="Boolean(newPassword?.dirty || confirmPassword?.dirty)"
                [error]="form?.errors?.['passwordMismatch']"
                [validationMessage]="'validation.passwordMismatch' | translate"/>
    </div>
    <div class="actions">
        <button (click)="bottomSheetRef.dismiss()" type="button" mat-stroked-button>
            {{ "Cancel" | translate }}
        </button>
        <button type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
            {{ "Change" | translate }}
        </button>
    </div>
</form>
